import React, { useState } from 'react';
import CertificatesPage from './CertificatesPage';
import { StaffTrainingPage } from './StaffPagesBundle';

// CredentialsHubPage consolidates Certificates + Staff Training into one
// workspace with internal tabs (both track expiry-bound credentials).
// Mirrors PharmacyPage / WhatsAppHubPage pattern.
const TABS = [
  { key: 'certificates', label: 'Certificates', render: (p) => <CertificatesPage {...p} /> },
  { key: 'training',     label: 'Training',     render: (p) => <StaffTrainingPage {...p} /> },
];

const LEGACY_MAP = {
  'certificates':   'certificates',
  'staff-training': 'training',
};

const CredentialsHubPage = ({ API_BASE, currentUser, initialTab = 'certificates' }) => {
  const [tab, setTab] = useState(LEGACY_MAP[initialTab] || initialTab);
  const Active = TABS.find(t => t.key === tab) || TABS[0];

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)}
            style={{
              padding: '9px 20px', borderRadius: 8, border: 'none', cursor: 'pointer',
              fontWeight: 600, fontSize: '0.86rem',
              backgroundColor: tab === t.key ? '#F97316' : '#e9ecef',
              color: tab === t.key ? 'white' : '#555',
            }}>
            {t.label}
          </button>
        ))}
      </div>
      {Active.render({ API_BASE, currentUser })}
    </div>
  );
};

export default CredentialsHubPage;
